"use client";

import { useEffect } from "react";

export function ThemeInit() {
  useEffect(() => {
    try {
      const savedScheme = localStorage.getItem("color-scheme");
      const systemDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      const theme = savedScheme || (systemDark ? "dark" : "light");

      const meta = document.querySelector('meta[name="color-scheme"]');
      if (meta) {
        (meta as HTMLMetaElement).content = theme === "dark" ? "dark" : "light";
      }

      if (theme === "dark") {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    } catch {
      // Ignore localStorage errors
    }
  }, []);

  return null;
}
